export abstract class DialogComponent {

  title: string;

  message: string;

  constructor(title: string, message: string) {

    this.title = title;
    this.message = message;
  }
}
